<div class="container bg-container p-1">
  <div class="jumbotron mb-3">
    <h1 class="jumbotron-headline" i18n>You were logged out successfully.</h1>
    <p class="jumbotron-lead" i18n>Please come back soon.</p>
  </div>

</div>

